import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DetectionStateComponent } from '../../components/detection-state/detection-state.component';
import { ImageSectionHeadComponent } from '../../components/image-section-head/image-section-head.component';
import { AccessVehicleResponse } from '../../services/http/access/access.interface';
import { AccessService } from '../../services/http/access/access.service';
import { Vehicle } from '../../services/http/vehicles/vehicles.interface';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-private-access',
  standalone: true,
  imports: [CommonModule, FormsModule, DetectionStateComponent, ImageSectionHeadComponent],
  templateUrl: './private-access.component.html',
  styleUrl: './private-access.component.scss'
})
export class PrivateAccessComponent {
  title = $localize`:@@Router.Private.Access:Accesos`;
  description = "";
  image = "assets/images/teclado.jpg";

  plate = '';
  accessList: AccessVehicleResponse | null = null;

  yearSelected = new Date().getFullYear();
  // from 2023 to current year
  years = Array.from({ length: new Date().getFullYear() - 2022 }, (v, k) => k + 2023);

  vehicles: Vehicle[] = [];
  vehicleSelected: Vehicle | null = null;

  noAccessText = "";
  error = "";

  constructor(
    private readonly accessService: AccessService,
    private readonly loaderService: LoaderService
  ) {
  }

  checkAccess() {
    if (!this.plate || this.plate.length < 6) {
      return;
    }
    this.error = "";
    this.noAccessText = "";
    this.loaderService.show();
    this.accessService.getAccessesByVehicle(this.plate, this.yearSelected).subscribe((accessesList) => {
      this.accessList = accessesList;
      if (this.accessList.municipalities.length == 0) {
        this.noAccessText = $localize`:@@access.error:No se encontraron accesos para el vehículo seleccionado.`;
        setTimeout(() => {
          document.getElementById("noAccessText")?.scrollIntoView({ behavior: 'smooth' });
          this.loaderService.hide();
        }, 100);
      } else {
        setTimeout(() => {
          document.getElementById("accesos")?.scrollIntoView({ behavior: 'smooth' });
          this.loaderService.hide();
        }, 100);
      }
    }, (error) => {
      if (error.status === 400) {
        this.error = error.error.message;
        setTimeout(() => {
          document.getElementById("error")?.scrollIntoView({ behavior: 'smooth' });
          this.loaderService.hide();
        }, 100);
      }
    });
  }

  getClass(percentaje: number) {
    if (percentaje < 60) {
      return 'bg-success';
    } else if (percentaje < 80) {
      return 'bg-warning';
    } else {
      return 'bg-danger';
    }
  }
}
